<template>
  <main-large-dialog
    v-bind="$props"
    :is-visible.sync="computedIsVisible"
    :title="dialogTitle"
    dialog-width="90%"
    min-body-height="70vh"
    @agree="saveHandler"
    :is-valid="currentTab === 0 ? isChartReady : isFetched"
    max-height="95vh"
    no-paddings-y
    no-paddings-x
    :agree-text="agreeButtonText"
    disagree-text="dialog.disagreeClose"
  >
    <template #body>
      <v-tabs v-model="currentTab" ref="tabs" class="fill-height d-flex flex-column" hide-slider color="font">
        <v-tab
          v-for="tab in tabs"
          :key="tab.value"
          :disabled="tab.disabled"
          active-class="activeTab"
          class="font--text"
          style="text-transform: none;"
        >
          {{ tab.text }}
        </v-tab>
        <v-tabs-items v-model="currentTab" class="fill-height">
          <v-tab-item style="height: inherit">
            <slot name="chart" />
          </v-tab-item>
          <v-tab-item style="height: inherit">
            <slot name="prepend-table" />
            <v-row no-gutters class="fill-height">
              <v-col cols="12" class="px-5 py-6">
                <v-data-table
                  :headers="tableData.headers"
                  height="auto"
                  class="waterBalanceReportsTable"
                  hide-default-footer
                  :items-per-page="-1"
                  fixed-header
                  :items="tableData.items"
                >
                  <template v-if="tableData.summary && tableData.items && tableData.items.length > 0" #[`body.append`]>
                    <tr class="sticky-footer-table elevation-3">
                      <td v-for="(item, index) in tableData.summary" class="top-border" :key="index">
                        {{ item }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </template>
  </main-large-dialog>
</template>

<script>
import MainLargeDialog from '@/components/MainLargeDialog';
import Chart from 'chart.js';

export default {
  name: 'WaterBalanceReportsMainDialog',
  components: {
    MainLargeDialog,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    isFetched: {
      type: Boolean,
      default: false,
    },
    isChartReady: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    tableData: {
      type: Object,
      default: () => ({
        headers: null,
        items: null,
        summary: null,
        fileName: null,
      }),
    },
  },
  data: () => ({
    currentTab: 0,
  }),
  watch: {
    isVisible() {
      this.currentTab = 0;
    },
  },
  computed: {
    tabs() {
      return [
        {
          text: this.$i18n.t('dialog.body.chart'),
          value: 'chart',
        },
        {
          text: this.$i18n.t('dialog.body.table'),
          value: 'table',
          disabled: !this.isFetched,
        },
      ];
    },
    agreeButtonText() {
      return this.currentTab === 0 ? 'dialog.downloadChart' : 'dialog.downloadTable';
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    generateChart(canvas, options) {
      Chart.plugins.register({
        afterRender: function(c) {
          const ctx = c.chart.ctx;
          ctx.save();
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, c.chart.width, c.chart.height);
          ctx.restore();
        },
      });
      this.chart = new Chart(canvas, options);
    },
    saveHandler() {
      if (this.currentTab === 0) {
        this.$_saveFile(this.chart.toBase64Image(), this.$i18n.t('dialog.body.chart'));
      } else {
        const mappedItems = this.tableData.items.map(item => {
          let itemsArray = [];
          this.tableData.headers.forEach(header => {
            itemsArray.push(item[header.value]);
          });
          return itemsArray;
        });

        const filename = this.tableData.fileName ? this.tableData.fileName : this.dialogTitle;

        let fileContent = `${filename}\n${this.tableData.headers
          .map(header => header.text)
          .join(';')}\n${mappedItems.map(item => item.join(';')).join('\n')}`;
        if (this.tableData.summary) {
          fileContent += `\n${Object.values(this.tableData.summary)
            .map(item => item)
            .join(';')}`;
        }
        const file = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' });
        this.$_saveFile(URL.createObjectURL(file), `${filename}.csv`);
      }
    },
  },
  beforeDestroy() {
    if (this.isChartReady) this.chart.destroy();
  },
};
</script>

<style lang="scss" scoped>
.sticky-footer-table {
  position: sticky;
  bottom: 0;
  background-color: #fff;
}
::v-deep {
  .v-data-table__wrapper {
    max-height: 450px;
  }
  .ag-center-cols-container {
    width: auto !important;
  }
  .v-input--selection-controls__input .v-icon {
    font-size: 19px;
  }
  .v-slide-group {
    z-index: 99;
    position: sticky;
    top: 0;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
  }
}

.activeTab {
  background-color: rgba(207, 207, 207, 0.25);
}

.top-border {
  @include border(top, 1px);
}

.waterBalanceReportsTable {
  @include border();
}
</style>
